 <mat-chip *ngIf="message && displayAlert" class="{{this.alert.type}}" selectable="false">
    {{message}}
</mat-chip>
